<template>
  <ModelEditFormPriceAgreement
    v-model="priceAgreement"
    :is-retrieving="isRetrieving"
    :project="project"
    variant="project"
    @input="wasChanged = true"
  />
</template>

<script setup lang="ts">
import { PurchaseItem } from "@/models/purchase-item.model"
import { Project } from "@/models/project.model"
import { inject } from "vue"
import { useProjectsPurchaseItemsStore } from "@/store/projects-purchase-items.store"
import { ProjectPurchaseItem } from "@/models/project-purchase-item.model"
import { useModelEditFormPriceAgreementManager } from "@/composables/administration/model-edit-form-project-price-agreement-manager"
import ModelEditFormPriceAgreement from "@/components/administrative_item/ModelEditFormPriceAgreement.vue"

const props = defineProps<{
  project: Project
  purchaseItem: PurchaseItem
}>()

const { priceAgreement, savePriceAgreement, isRetrieving, wasChanged } =
  useModelEditFormPriceAgreementManager<PurchaseItem, ProjectPurchaseItem>(
    props.project,
    props.purchaseItem,
    useProjectsPurchaseItemsStore(),
    inject("projectPurchaseItemController")!,
    ProjectPurchaseItem
  )

defineExpose({ savePriceAgreement })
</script>

<style scoped></style>
